import { render, staticRenderFns } from "./CsActionsV2.vue?vue&type=template&id=52417366&scoped=true&"
import script from "./CsActionsV2.vue?vue&type=script&lang=js&"
export * from "./CsActionsV2.vue?vue&type=script&lang=js&"
import style0 from "./CsActionsV2.vue?vue&type=style&index=0&id=52417366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52417366",
  null
  
)

export default component.exports